<script>
import {
  authComputed,
  authMethods,
  organizationComputed,
} from '@state/helpers';

export default {
  components: {},
  props: {},
  data() {
    return {};
  },
  computed: {
    ...authComputed,
    ...organizationComputed,
  },
  mounted() {},
  methods: {
    ...authMethods,
    async goToOnboarding() {
      this.SET_AUTH_CHECKED(false);
      window.location.href = this.currentUser.trainer.onboardUrl;
    },
    handleOk(bvModalEvt) {
      // Prevent modal from closing
      bvModalEvt.preventDefault();
    },
    goBack() {
      this.$router.back();
    },
  },
};
</script>

<template class="modal-confirmation">
  <b-modal
    id="onboarding-modal"
    centered
    @hide="handleOk"
    :hide-header-close="true"
    :hide-header="true"
    :hide-footer="true"
  >
    <template slot="default">
      <div>
        <p class="modal-text-main">Set up {{ organizationTitle }} Pay</p>
        <p class="modal-text-second"
          >In order to receive payment from clients, please complete your
          banking details.
        </p>
        <div class="actions">
          <BaseButton class="btn-secondary btn-round" @click="goToOnboarding">
            {{ organizationTitle }} PAY Set Up
          </BaseButton>
        </div>
        <div class="actions">
          <BaseButton class="btn-secondary btn-round" @click="goBack">
            Go Back
          </BaseButton>
        </div>
      </div>
    </template>
  </b-modal>
</template>

<style lang="scss" scoped>
@import '@design';

// stylelint-disable selector-pseudo-element-no-unknown

.modal-dialog > .modal-content {
  .modal-text-main {
    color: $color-black-one;
    font-size: 28px;
    font-style: normal;
    font-weight: 900;
    letter-spacing: -0.233333px;
    line-height: 3.3rem;
    margin-left: 3rem;
    margin-right: 3rem;
    margin-top: 2rem;
    text-align: center;
  }
  .modal-text-second {
    color: $color-black-one;
    font-size: 18px;
    font-weight: 800;
    letter-spacing: -0.233333px;
    text-align: center;
  }
  .actions {
    display: flex;
    justify-content: space-around;
    padding-bottom: 2rem;
    padding-top: 2rem;
    .button {
      align-items: center;
      display: flex;
      height: 4rem;
      justify-content: center;
      white-space: nowrap;
      width: 50%;
    }
  }
}

::v-deep .modal-dialog {
  min-width: 40%;
  .modal-content {
    background: $color-white;
    border-radius: 12px !important;
    box-shadow: 0 4px 8px rgba($color-black-wo-rgb, 0.08);
  }
}
</style>
